import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const InformationForReaders = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    alert('Subscription successful! You will receive notifications about new publications.');
    setEmail('');
  };

  return (
    <div className="container py-4">
      <div className="row mb-5">
        <div className="col-lg-8 mx-auto">
          <h1 className="mb-4 text-center">Information for Readers</h1>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Welcome to FUWJALS</h2>
              <p className="card-text">
                The Federal University Wukari Journal of Agriculture and Life Sciences (FUWJALS) 
                provides free access to cutting-edge research in agriculture and life sciences. 
                Our open access policy ensures that scientific knowledge is available to readers 
                worldwide without barriers.
              </p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">How to Access Content</h2>
              <div className="row">
                <div className="col-md-6">
                  <h4>Browse by Issue</h4>
                  <ul>
                    <li>Visit our <Link to="/issues">Current Issues</Link> page</li>
                    <li>Select the volume and issue of interest</li>
                    <li>Browse articles by title or author</li>
                    <li>Click on article titles to view abstracts</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Search Content</h4>
                  <ul>
                    <li>Use our <Link to="/search">Advanced Search</Link> feature</li>
                    <li>Search by keywords, author names, or topics</li>
                    <li>Filter results by publication date</li>
                    <li>Access full-text PDFs directly</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Publication Schedule</h2>
              <div className="row">
                <div className="col-md-6">
                  <h4>Regular Issues</h4>
                  <ul>
                    <li><strong>Issue 1:</strong> March (published March 15)</li>
                    <li><strong>Issue 2:</strong> June (published June 15)</li>
                    <li><strong>Issue 3:</strong> September (published September 15)</li>
                    <li><strong>Issue 4:</strong> December (published December 15)</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Special Features</h4>
                  <ul>
                    <li>Special issues on topical themes</li>
                    <li>Conference proceedings supplements</li>
                    <li>Thematic collections</li>
                    <li>Early online publication</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Stay Updated</h2>
              <h4>Email Notifications</h4>
              <p className="card-text">
                Subscribe to receive email notifications when new issues are published. 
                You can unsubscribe at any time.
              </p>
              <form onSubmit={handleSubscribe} className="row g-3">
                <div className="col-md-8">
                  <input 
                    type="email" 
                    className="form-control" 
                    placeholder="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required 
                  />
                </div>
                <div className="col-md-4">
                  <button type="submit" className="btn btn-primary w-100">Subscribe</button>
                </div>
              </form>
              
              <h4 className="mt-4">RSS Feeds</h4>
              <ul>
                <li><a href="/rss/latest-articles">Latest Articles RSS</a></li>
                <li><a href="/rss/current-issue">Current Issue RSS</a></li>
                <li><a href="/rss/announcements">Announcements RSS</a></li>
              </ul>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Using Our Content</h2>
              <h4>Open Access License</h4>
              <p className="card-text">
                All articles published in FUWJALS are available under a Creative Commons 
                Attribution License. This means you can:
              </p>
              <ul>
                <li>Read and download articles for free</li>
                <li>Share articles with colleagues and students</li>
                <li>Use content for educational purposes</li>
                <li>Include articles in course materials</li>
                <li>Cite and reference our publications</li>
              </ul>
              
              <h4>Citation Guidelines</h4>
              <p className="card-text">When citing FUWJALS articles, please use the following format:</p>
              <div className="bg-light p-3 rounded">
                <code>
                  Author, A. A. (Year). Article title. Federal University Wukari Journal of 
                  Agriculture and Life Sciences, Volume(Issue), pages. DOI or URL
                </code>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Research Areas Covered</h2>
              <div className="row">
                <div className="col-md-6">
                  <ul>
                    <li>Agricultural Economics and Extension</li>
                    <li>Animal Science and Production</li>
                    <li>Crop Science and Production</li>
                    <li>Soil Science and Land Management</li>
                    <li>Agricultural Engineering</li>
                    <li>Food Science and Technology</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <ul>
                    <li>Forestry and Wildlife Management</li>
                    <li>Fisheries and Aquaculture</li>
                    <li>Environmental Sciences</li>
                    <li>Plant and Animal Biotechnology</li>
                    <li>Agricultural Biodiversity</li>
                    <li>Climate Change and Agriculture</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">For Librarians</h2>
              <h4>Archiving and Indexing</h4>
              <ul>
                <li>All issues are permanently archived</li>
                <li>Full-text searchable content</li>
                <li>DOI assignment for all articles</li>
                <li>LOCKSS and CLOCKSS participation</li>
                <li>Institutional repository compatibility</li>
              </ul>
              
              <h4>Usage Statistics</h4>
              <ul>
                <li>Monthly download reports available</li>
                <li>Geographic usage data</li>
                <li>Most accessed articles tracking</li>
                <li>Citation metrics and impact data</li>
              </ul>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Technical Requirements</h2>
              <div className="row">
                <div className="col-md-6">
                  <h4>System Requirements</h4>
                  <ul>
                    <li>Modern web browser</li>
                    <li>PDF reader (Adobe Acrobat or equivalent)</li>
                    <li>Stable internet connection</li>
                    <li>JavaScript enabled</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h4>Mobile Access</h4>
                  <ul>
                    <li>Responsive design for all devices</li>
                    <li>Mobile-optimized reading experience</li>
                    <li>Touch-friendly navigation</li>
                    <li>Offline reading capability</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Reader Services</h2>
              <h4>Customer Support</h4>
              <ul>
                <li>Technical assistance for access issues</li>
                <li>Help with search and navigation</li>
                <li>Citation format guidance</li>
                <li>Content usage questions</li>
              </ul>
              
              <h4>Contact Information</h4>
              <p className="card-text">
                <strong>Reader Services</strong><br />
                Email: readers@fuwukari.edu.ng<br />
                Phone: +234 XXX XXX XXXX<br />
                Hours: Monday-Friday, 9:00 AM - 5:00 PM (WAT)
              </p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h2 className="card-title">Feedback and Suggestions</h2>
              <p className="card-text">
                We value your feedback and suggestions for improving our service. 
                Please let us know how we can better serve the scientific community.
              </p>
              <div className="row">
                <div className="col-md-6">
                  <h5>Ways to Provide Feedback</h5>
                  <ul>
                    <li>Email us at feedback@fuwukari.edu.ng</li>
                    <li>Use our online contact form</li>
                    <li>Participate in reader surveys</li>
                    <li>Connect on social media</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h5>Areas for Feedback</h5>
                  <ul>
                    <li>Website usability and design</li>
                    <li>Content quality and relevance</li>
                    <li>Search and discovery features</li>
                    <li>Mobile experience</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="text-center">
            <Link to="/issues" className="btn btn-primary me-3">Browse Current Issues</Link>
            <Link to="/search" className="btn btn-outline-secondary">Search Articles</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformationForReaders;